__turbopack_context__.v({
  "root": "ForecastTable-module__-NA_Mq__root",
});
